<template>
  <div class="d-flex justify-content-between align-items-center py-4">
    <h6 class="grid-header-font-size title m-0">{{ title }}</h6>
    <div class="float-end">
      <div class="d-inline-flex justify-content-center">
        <date-range-filter
          class="me-2"
          :selected-date="dateSelection"
          :last-date="today"
          @change="$emit('date-change', $event)"
        />
        <workgroup-search
          :workgroups="workgroups"
          :date-range="dateSelection"
          :selected="selectedWorkgroups"
          :loading="workgroupsLoading"
          @select="$emit('workgroups-change', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DateRangeFilter from '../dateRangeFilter.vue';
import WorkgroupSearch from '../workgroupSearch.vue';

/**
 * Title bar of a dashboard: its name, the date range and the campus / route group filter that the
 * whole dashboard follows. Holds no state of its own — the dashboard owns both selections.
 */
export default {
  name: 'DashboardHeader',
  components: { DateRangeFilter, WorkgroupSearch },
  props: {
    title: {
      type: String,
      required: true,
    },
    // { type, fromDate, toDate } as date-range-filter takes it; the range also labels a custom selection,
    // and workgroup-search lists only the route groups whose period overlaps it.
    dateSelection: {
      type: Object,
      required: true,
    },
    // Workgroup instances for workgroup-search, and the ones currently picked.
    workgroups: {
      type: Array,
      default: () => [],
    },
    selectedWorkgroups: {
      type: Array,
      default: () => [],
    },
    workgroupsLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['date-change', 'workgroups-change'],
  setup() {
    // Custom ranges can't end after today.
    return { today: new Date() };
  },
};
</script>
